import { jsPDF } from 'jspdf';
import { PDF_EXPORT_SCALE, captureExportElement } from './exportCaptureUtils';

const PAGE_MARGIN_MM = 14;
const PAGE_WIDTH_MM = 210;
const PAGE_HEIGHT_MM = 297;
const CARD_TITLE_HEIGHT_MM = 8;
const CARD_GAP_MM = 6;

const addTitlePage = (pdf, { title, generatedAt, filterSummary }) => {
  let y = PAGE_MARGIN_MM + 4;

  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(18);
  pdf.setTextColor(16, 42, 67);
  pdf.text(title, PAGE_MARGIN_MM, y);
  y += 12;

  pdf.setFont('helvetica', 'normal');
  pdf.setFontSize(10);
  pdf.setTextColor(71, 85, 105);
  pdf.text(generatedAt, PAGE_MARGIN_MM, y);
  y += 10;

  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(11);
  pdf.setTextColor(16, 42, 67);
  pdf.text('Current filter values', PAGE_MARGIN_MM, y);
  y += 7;

  pdf.setFont('helvetica', 'normal');
  pdf.setFontSize(10);
  filterSummary.forEach(({ label, value }) => {
    pdf.text(`${label}: ${value}`, PAGE_MARGIN_MM + 2, y);
    y += 6;
  });
};

const addCardToPdf = (pdf, { label, canvas, startNewPage = true }) => {
  const contentWidth = PAGE_WIDTH_MM - PAGE_MARGIN_MM * 2;
  const firstPageAvailableHeight =
    PAGE_HEIGHT_MM - PAGE_MARGIN_MM * 2 - CARD_TITLE_HEIGHT_MM - CARD_GAP_MM;

  let renderWidth = contentWidth;
  let renderHeight = (canvas.height * renderWidth) / canvas.width;

  if (renderHeight <= firstPageAvailableHeight) {
    if (startNewPage) {
      pdf.addPage();
    }

    let y = PAGE_MARGIN_MM;
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(12);
    pdf.setTextColor(16, 42, 67);
    pdf.text(label, PAGE_MARGIN_MM, y);
    y += CARD_TITLE_HEIGHT_MM;

    const xOffset = PAGE_MARGIN_MM + Math.max(0, (contentWidth - renderWidth) / 2);
    pdf.addImage(canvas.toDataURL('image/png'), 'PNG', xOffset, y, renderWidth, renderHeight);
    return y + renderHeight + CARD_GAP_MM;
  }

  const scaleFactor = firstPageAvailableHeight / renderHeight;
  renderHeight = firstPageAvailableHeight;
  renderWidth *= scaleFactor;

  if (startNewPage) {
    pdf.addPage();
  }

  let y = PAGE_MARGIN_MM;
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(12);
  pdf.setTextColor(16, 42, 67);
  pdf.text(label, PAGE_MARGIN_MM, y);
  y += CARD_TITLE_HEIGHT_MM;

  const xOffset = PAGE_MARGIN_MM + Math.max(0, (contentWidth - renderWidth) / 2);
  pdf.addImage(canvas.toDataURL('image/png'), 'PNG', xOffset, y, renderWidth, renderHeight);

  return y + renderHeight + CARD_GAP_MM;
};

export const generateDashboardPdf = async ({
  title,
  filterSummary,
  selectedItems,
  fileName,
}) => {
  if (!selectedItems.length) {
    throw new Error('Select at least one card to export.');
  }

  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const generatedAt = new Date().toLocaleString();

  addTitlePage(pdf, { title, generatedAt, filterSummary });

  for (let index = 0; index < selectedItems.length; index += 1) {
    const item = selectedItems[index];
    const element = document.getElementById(item.id);

    if (!element) {
      // eslint-disable-next-line no-continue
      continue;
    }

    // eslint-disable-next-line no-await-in-loop
    const canvas = await captureExportElement(element, PDF_EXPORT_SCALE);
    addCardToPdf(pdf, {
      label: item.label,
      canvas,
      startNewPage: true,
    });
  }

  pdf.save(fileName);
};
